import { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Menu, X, ShoppingCart, Cpu } from 'lucide-react';
import { useCartStore } from '../store/cartStore';

const NAV_LINKS = [
  { path: '/', label: '首頁' },
  { path: '/store', label: '商店' },
  { path: '/story', label: '品牌故事' },
  { path: '/media-coverage', label: '媒體報導' },
  { path: '/order/query', label: '訂單查詢' },
];

export default function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const totalItems = useCartStore((s) => s.totalItems());

  const isActive = (path: string) => location.pathname === path;

  return (
    <header className="sticky top-0 z-50 bg-x1493-dark/95 backdrop-blur-md border-b border-white/10">
      <div className="max-w-6xl mx-auto px-4 py-3 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2">
          <div className="w-10 h-10 rounded-xl bg-x1493-primary flex items-center justify-center shrink-0">
            <Cpu size={22} className="text-white" />
          </div>
          <div className="block">
            <span className="text-lg sm:text-xl font-bold text-white tracking-wide">Kare Tech</span>
            <p className="text-[9px] sm:text-[10px] text-x1493-secondary tracking-wider">IT &amp; ENGINEERING</p>
          </div>
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-1">
          {NAV_LINKS.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`px-4 py-2 rounded-xl text-sm font-medium transition ${
                isActive(link.path)
                  ? 'text-x1493-primary bg-white'
                  : 'text-white/80 hover:text-white hover:bg-white/10'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        {/* Actions */}
        <div className="flex items-center gap-2">
          <button
            onClick={() => navigate('/store')}
            className="relative p-2 rounded-xl text-white hover:bg-white/10 transition"
            aria-label="購物車"
          >
            <ShoppingCart size={22} />
            {totalItems > 0 && (
              <span className="absolute -top-1 -right-1 bg-x1493-primary text-white text-[10px] font-bold w-5 h-5 rounded-full flex items-center justify-center">
                {totalItems}
              </span>
            )}
          </button>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden p-2 rounded-xl text-white hover:bg-white/10 transition"
            aria-label="選單"
          >
            {mobileOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Nav */}
      {mobileOpen && (
        <div className="md:hidden border-t border-white/10 bg-x1493-dark px-4 pb-4">
          <nav className="flex flex-col gap-1 pt-2">
            {NAV_LINKS.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setMobileOpen(false)}
                className={`px-4 py-3 rounded-xl text-base font-medium transition ${
                  isActive(link.path)
                    ? 'text-x1493-primary bg-white'
                    : 'text-white/80 hover:text-white hover:bg-white/10'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}
